import React from 'react';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { AccountHeaderWrapper } from './AccountHeader.style';
import { Icon } from '../../../CommonComponents/OPL/Icon/Icon';
import { TabSlug } from '../../types';

export const AccountHeader = ({ clientId }) => {
  return (
    <AccountHeaderWrapper
      onClick={() =>
        ADV.util.Router.go2('AccountPerformanceReporting', {
          clientId,
          tabSlug: TabSlug.Summary,
          isApex: false,
        })
      }
    >
      <Icon className="fas fa-chevron-left" />

      <Text
        ml="8"
        fontWeight={500}
        color="neutral.600"
        css="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"
      >
        My Accounts
      </Text>
    </AccountHeaderWrapper>
  );
};
